import React from "react";
// import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import rightArrow from '../../assets/images/right-arrow.svg';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { IMeetingVenueData } from "../../types/api/eventApi";
import { NoData } from "../common/NoData";
import { useTranslation } from "react-i18next";
import { IMeetingVenue } from "../../types/features/multiLanguageSlice";
const Venue: React.FC<{ meeting_venue: Array<IMeetingVenueData> }> = ({ meeting_venue }) => {
    const {t} = useTranslation()
    const meeting_venue_json = t('meeting_event.meeting_venue', { returnObjects: true })  as IMeetingVenue[];

    const venueSlider = {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        speed: 300,
        margin: '30px',
        infinite: true,
        autoplaySpeed: 5000,
        autoplay: true,
        responsive: [
            {
                breakpoint: 1099,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    centerMode: false,
                    arrows: false,
                    dots: true,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: false,
                    arrows: false,
                    dots: true,
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                    arrows: false,
                    dots: true,
                }
            }
        ]
    };
    return (
        <div>
            <div>
                <section className='venue-section'>
                    <div className="container">
                        <div className="venue-heading">
                            <h3 className="title">{t('meeting_event.conference_title')}</h3>
                        </div>
                        <div className="venue-slider">
                            <Slider {...venueSlider}>
                                {
                                    meeting_venue && meeting_venue.length > 0 ?
                                        meeting_venue.map((venue: IMeetingVenueData, index: number) => (
                                            <div className="venue-card" key={"Meeting_Venue" + index}>
                                                <div className="venue-img">
                                                    <img src={venue.image} alt="img" className="img-fluid"></img>
                                                </div>
                                                <div className="card-content">
                                                    <h4 className="title">{meeting_venue_json && meeting_venue_json.length>0 && meeting_venue_json[index].name}</h4>
                                                    <p className="text">{meeting_venue_json && meeting_venue_json.length>0 &&  meeting_venue_json[index].description}</p>
                                                    <Link to="#" onClick={() => window.location.href = venue.link}>{t('meeting_event.plan_event.inquiry_now')}<span className="right-arrow"><img src={rightArrow} alt="icon" className="img-fluid"></img></span></Link>
                                                </div>
                                            </div>
                                        ))
                                        : <NoData message="Oops, No Dining Amininty Data Found!!" />
                                }
                            </Slider>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}
export default Venue;